export const defaultTransfersColumnState = {
  transfers_cv: ['businessOrAdvisor', 'movementType', 'autoInvest'], // columns that are _not_ visible by default
};
